import { Controller } from "stimulus";

export default class TogglerController extends Controller {
  get className() {
    return this.data.get("className") || "active";
  }

  connect() {
    // save className state
    this.withClass = this.element.classList.contains(this.className);
  }

  disconnect() {
    // reset className init state
    if (this.withClass) {
      this.element.classList.add(this.className);
    } else {
      this.element.classList.remove(this.className);
    }
  }

  toggle() {
    this.element.classList.toggle(this.className);
  }
}
